import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import StepButton from "components/views/StepButton";
import Spinner from "components/views/atoms/Spinner";

const Wrapper = styled.ul`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacer}px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  position: relative;

  &.loading {
    min-height: 100px;
  }

  ${({ theme }) => theme.mediaQueries.medium} {
    grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  }
`;

const StepsListView = ({ className, list, onClick }) => {
  const classes = ["StepsListView"];

  if (className) classes.push(className);
  if (list === undefined) classes.push("loading");

  function handleClick(item) {
    return () => onClick(item);
  }

  return (
    <Wrapper className={classes.join(" ")}>
      {list === undefined && <Spinner relativeToParent />}
      {list &&
        list.map((item) => (
          <li key={item.key}>
            <StepButton label={item.label} onClick={handleClick(item)} />
          </li>
        ))}
    </Wrapper>
  );
};

StepsListView.displayName = "StepsListView";

StepsListView.propTypes = {
  className: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    })
  ),
  onClick: PropTypes.func,
};

StepsListView.defaultProps = {
  className: null,
  list: undefined,
  onClick: () => {},
};

export default StepsListView;
